import React from 'react';
import Box from '@mui/material/Box';


import type { LegacyManufacturerCardWarningProps } from '../../types/LegacyManufacturerCardWarningProps';
import NotificationAlert from '../../../../ui/NotificationAlert/NotificationAlert';
import {
  LEGACY_MF_CARD_WARNING_MESSAGE,
  LEGACY_MF_CARD_WARNING_TITLE,
} from '../../dev/constants';

const LegacyManufacturerCardWarning: React.FC<
  LegacyManufacturerCardWarningProps
> = ({ id }) => {
  return (
    <Box sx={{ marginTop: '12px', marginBottom: '12px' }}>
      <NotificationAlert
        severity="warning"
        title={LEGACY_MF_CARD_WARNING_TITLE}
        message={LEGACY_MF_CARD_WARNING_MESSAGE}
        id={id}
      />
    </Box>
  );
};

export default LegacyManufacturerCardWarning;
